import { useContext, useEffect, useMemo, useState } from "react";
import { FilterContext } from "src/components/Common/UI/DndTable/TableFilterV2/FilterContext";
import { useGetAllOteConTypes } from "../api/getAllOteConTypes";
import { useTranslation } from "react-i18next";

// All your logic is here
export const useOteConTypesDataViewLogic = () => {
  const { submitedFilters } = useContext(FilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({ action: "", selectedRows: [] });
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetOteConType []>([]);
  const getAllOteConTypesQuery = useGetAllOteConTypes({data: submitedFilters ? submitedFilters : {}});
  const { t } = useTranslation();

  const loadingDone = [getAllOteConTypesQuery].every(
    ({ isFetching  }) => !isFetching
  );

  const errorData = [getAllOteConTypesQuery].filter(
    ({ isError }) => (isError ? true : false)
  );

  const data = getAllOteConTypesQuery.data ? getAllOteConTypesQuery.data : []

  const columns = useMemo(
    () => [
      {
          id: "1",
          Header: "Είδος γραμμής ΟΤΕ",
          accessor: "description",
          show : true,
          isDraggable: false,
      },
  
    ], []
  );

  const closeActionModal = () => {
    setModalEvent({action: "", selectedRows: []});
  }

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία Είδους γραμμής ΟΤΕ");
        break;
      case "edit":
        title = t("Επεξεργασία Είδους γραμμής ΟΤΕ");
        break
        case "delete":
        title = t("Διαγραφή Είδους γραμμής ΟΤΕ");
        break
      default:
        break;
    }
    return title;
  }

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable[0] ? [...[selectedRowsOfTable[0].id]] : [];
    console.log("selectedRows", selectedRows, "selectedRowOfTable", selectedRowsOfTable, "selectedRowOfTable[0]", selectedRowsOfTable[0])
    setModalEvent({action: event.action, selectedRows: selectedRows})
  }

  useEffect(()=>{
    setSelectedRowsOfTable([]);
    getAllOteConTypesQuery.refetch();
  },[ submitedFilters ])


  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction
  };
};
